import { mutate } from 'swr';
import axios from 'axios';
import { GridSelectionModel } from '@mui/x-data-grid/models/gridSelectionModel';
import { SERVICES } from '@shared/constants/apiConfig';
import { Notistack } from '@shared/components/Notistack/Notistack';

export interface IContactListItem {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  leadId?: string;
  homePhone: string;
  workPhone: string;
  cellPhone: string;
  contactSource?: unknown;
  source?: string;
  contactCreatedDate: Date;
  leadReceivedDate: Date;
}

export interface IContactsListResponse {
  data: {
    totalCount: number;
    items: IContactListItem[];
  }
}

const path = `/${SERVICES.CONTACT}/contacts`;

export const requestAssignContacts = (userId: string, contacts: GridSelectionModel) => {
  return mutate(path, async() => {
    try {
      await axios.post(`/${SERVICES.CONTACT}/assignUser/${userId}`, contacts);
      Notistack.successMessage('Contacts - Assigned Successfully');
    } catch (err) {
      const error = (err as { response: { data: { message: string } } })?.response?.data?.message;
      Notistack.generalError(error);
    }
  });
};
